var _g, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenuCallendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calendar",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "calendar-2",
    "data-name": "calendar",
    transform: "translate(-0.25 -0.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30833",
    "data-name": "Path 30833",
    d: "M8,5.75A.755.755,0,0,1,7.25,5V2a.75.75,0,0,1,1.5,0V5A.755.755,0,0,1,8,5.75Z",
    transform: "translate(0.139)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30834",
    "data-name": "Path 30834",
    d: "M16,5.75A.755.755,0,0,1,15.25,5V2a.75.75,0,0,1,1.5,0V5A.755.755,0,0,1,16,5.75Z",
    transform: "translate(0.361)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30835",
    "data-name": "Path 30835",
    d: "M8.5,14.5a1,1,0,0,1-.38-.08.96.96,0,0,1-.62-.92,1,1,0,0,1,.08-.38,1.155,1.155,0,0,1,.21-.33,1.032,1.032,0,0,1,.33-.21,1.021,1.021,0,0,1,1.09.21,1.052,1.052,0,0,1,.29.71,1.5,1.5,0,0,1-.02.2.636.636,0,0,1-.06.18.757.757,0,0,1-.09.18,1.576,1.576,0,0,1-.12.15A1.052,1.052,0,0,1,8.5,14.5Z",
    transform: "translate(0.15 0.289)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30836",
    "data-name": "Path 30836",
    d: "M12,14.5a1,1,0,0,1-.38-.08A.96.96,0,0,1,11,13.5a1,1,0,0,1,.08-.38,1.155,1.155,0,0,1,.21-.33,1.032,1.032,0,0,1,.33-.21,1,1,0,0,1,1.09.21,1.052,1.052,0,0,1,.29.71,1.5,1.5,0,0,1-.02.2.636.636,0,0,1-.06.18.757.757,0,0,1-.09.18,1.576,1.576,0,0,1-.12.15A1.052,1.052,0,0,1,12,14.5Z",
    transform: "translate(0.25 0.288)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30837",
    "data-name": "Path 30837",
    d: "M15.5,14.5a1,1,0,0,1-.38-.08,1.032,1.032,0,0,1-.33-.21l-.12-.15a.757.757,0,0,1-.09-.18.636.636,0,0,1-.06-.18,1.5,1.5,0,0,1-.02-.2,1.052,1.052,0,0,1,.29-.71,1.032,1.032,0,0,1,.33-.21,1,1,0,0,1,1.09.21,1.052,1.052,0,0,1,.29.71,1.5,1.5,0,0,1-.02.2.636.636,0,0,1-.06.18.757.757,0,0,1-.09.18,1.576,1.576,0,0,1-.12.15A1.052,1.052,0,0,1,15.5,14.5Z",
    transform: "translate(0.35 0.288)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30838",
    "data-name": "Path 30838",
    d: "M8.5,18a1,1,0,0,1-.38-.08,1.155,1.155,0,0,1-.33-.21A1.052,1.052,0,0,1,7.5,17a1,1,0,0,1,.08-.38.933.933,0,0,1,.21-.33A1,1,0,1,1,8.5,18Z",
    transform: "translate(0.15 0.378)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30839",
    "data-name": "Path 30839",
    d: "M12,18a.99.99,0,0,1-1-1,1,1,0,0,1,.08-.38.933.933,0,0,1,.21-.33,1.047,1.047,0,0,1,1.42,0,.933.933,0,0,1,.21.33A1,1,0,0,1,13,17a.99.99,0,0,1-1,1Z",
    transform: "translate(0.25 0.378)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30840",
    "data-name": "Path 30840",
    d: "M15.5,18a1.052,1.052,0,0,1-.71-.29.933.933,0,0,1-.21-.33.943.943,0,0,1,0-.76.933.933,0,0,1,.21-.33,1,1,0,0,1,.9-.27.6.6,0,0,1,.19.06.757.757,0,0,1,.18.09,1.575,1.575,0,0,1,.15.12A1,1,0,0,1,15.5,18Z",
    transform: "translate(0.35 0.378)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30841",
    "data-name": "Path 30841",
    d: "M20.98,9.84H3.52a.75.75,0,1,1,0-1.5H20.98a.75.75,0,1,1,0,1.5Z",
    transform: "translate(0 0.177)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30842",
    "data-name": "Path 30842",
    d: "M16.353,23.25H8.147c-3.744,0-5.9-2.153-5.9-5.894V8.644C2.25,4.9,4.4,2.75,8.147,2.75h8.205c3.744,0,5.9,2.152,5.9,5.894v8.713C22.25,21.1,20.1,23.25,16.353,23.25ZM8.147,4.287c-2.933,0-4.359,1.425-4.359,4.356v8.713c0,2.931,1.426,4.356,4.359,4.356h8.205c2.933,0,4.359-1.425,4.359-4.356V8.644c0-2.932-1.426-4.356-4.359-4.356Z",
    transform: "translate(0 0)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8466",
    "data-name": "Rectangle 8466",
    width: 24,
    height: 24,
    fill: "none"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuCallendar);
export default __webpack_public_path__ + "static/media/menu-callendar.ec73b58b0a168936be6b8745672d4219.svg";
export { ForwardRef as ReactComponent };